module.exports = __webpack_public_path__ + "static/media/natura.00f783eb.svg";